
import { Component, Vue } from 'vue-property-decorator'
import AppBox from '@/components/AppBox.vue'
import AppInput from '@/components/AppInput.vue'
import { DebouncedFunc, debounce, cloneDeep } from 'lodash'
import { ChildComponentMixin } from '@/mixins'

@Component({
    components: {
        AppBox,
        AppInput,
    },
})

export default class PartnersSearch extends ChildComponentMixin {
    public nameOrCnpj: string = ''
    public category: string = ''
    public status: string = ''
    public apikeyStatus: string = ''

    private debounced: DebouncedFunc<(() => {})> | null = null

    get categoriesOptions(): InputSelectOptionEntity[] {
        const categories = cloneDeep(this.$store.state.partners.categories)

        const mappedCategories = categories.map((category: PartnerCategoryEntity) => {
            return { value: category.id.toString(), text: category.name }
        })

        const emptyCategory = [{ value: '', text: '' }]
        const allCategories = emptyCategory.concat(mappedCategories)

        return allCategories
    }

    get statusOptions(): InputSelectOptionEntity[] {
        return [
            { value: '', text: '' },
            { value: 'INITIATED', text: 'Iniciada' },
            { value: 'FINISHED', text: 'Finalizada' },
        ]
    }

    get apikeyStatusOptions(): InputSelectOptionEntity[] {
        return [
            { value: '', text: '' },
            { value: 'ACTIVE', text: 'Ativo' },
            { value: 'INACTIVE', text: 'Inativo' },
        ]
    }

    public async mounted() {
        const nameOrCnpj = this.$route.query.nameOrCnpj
        const category = this.$route.query.category
        const status = this.$route.query.status
        const apikeyStatus = this.$route.query.apikeyStatus

        if (nameOrCnpj !== null && typeof nameOrCnpj === 'string') {
            this.nameOrCnpj = nameOrCnpj
        }

        if (category !== null && typeof category === 'string') {
            this.category = category
        }

        if (status !== null && typeof status === 'string') {
            this.status = status
        }

        if (apikeyStatus !== null && typeof apikeyStatus === 'string') {
            this.apikeyStatus = apikeyStatus
        }

        this.search()
    }

    public search() {
        this.$store.dispatch('partners/filterPartners', {
            nameOrCnpj: this.nameOrCnpj,
            category: this.category,
            status: this.status,
            apikeyStatus: this.apikeyStatus,
        })
    }

    private onTypeSearch() {
        if (this.debounced != null) {
            this.debounced.cancel()
        }
        this.debounced = debounce(async () => {
            this.search()
        }, 1000)
        this.debounced()
    }
}
